import Axios from '../Axios';
import { fetchUser } from '../utils/fetchUser';


export const uploadFile = async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await Axios.post('/file/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      
    //  const data = await response.json();
    //  return data; // .fileId

     return response.data;
    } catch (error) {
      console.error('Error al subir el archivo:', error);
      throw error;
    }
  };
  
  export const fetchFileUrl = async (fileId) => {
    const response = await Axios.get(`/file/download/${fileId}`, { responseType: 'blob' });
    const contentType = response.headers['content-type'] || 'application/pdf';
    const blob = new Blob([response.data], { type: contentType });
    return window.URL.createObjectURL(blob);
  };

  export const downloadFile = async (fileId, nombreArchivo = 'documento') => {
    try {
      const response = await Axios.get(`/file/download/${fileId}`, {
        responseType: 'blob',
      });

      const contentType = response.headers['content-type'] || 'application/octet-stream';
      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
  
      // 🧠 Crear link invisible para descargar
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nombreArchivo);
      document.body.appendChild(link);
      link.click();
      link.remove();
  
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
      throw error;
    }
  };
  
